import type { SubmittedOrder } from './orders.js';
import { eligibleOrderablePackages } from './orders-wire.js';
import type { Package } from './packages.js';

/**
 * The Dashboard's three counts (MYP-27), over data the app already holds.
 *
 * Each one is the same rule another screen already applies, so a tile can never disagree with the
 * page it links to:
 *
 * - **Ready to order** — `eligibleOrderablePackages`, the rule Create order's Step 1 uses: a
 *   package whose status is on the vendor's own `package_status_for_order_list` (live: `NEW`,
 *   `ARRIVE`, `IN` — on the way counts, since an order can be placed before everything arrives)
 *   and which is not already on an order.
 * - **Awaiting payment** — orders in the `unpaid` group (`PACK`, `PARTPACK`; see `toOrderStatus`):
 *   the ones whose card carries Pay.
 * - **Confirm receipt** — orders in the `shipped` group (`DESPATCH`, `PARTDESPATCH`, `DESPNOPAY`,
 *   `TRANSIT`, `ARRIVEDPICK`): the ones whose card carries Confirm receipt.
 */
export function readyToOrderCount(
  packages: readonly Package[],
  eligibleStatusCodes: readonly string[],
): number {
  return eligibleOrderablePackages(packages, eligibleStatusCodes).length;
}

export function awaitingPaymentCount(orders: readonly SubmittedOrder[]): number {
  return orders.filter((order) => order.status === 'unpaid').length;
}

export function confirmReceiptCount(orders: readonly SubmittedOrder[]): number {
  return orders.filter((order) => order.status === 'shipped').length;
}
